<template>
  <div class="flex flex-col h-full overflow-y-hidden bg-white mx-10 mt-5 p-5">
    <div class="border-b pb-5 flex items-center w-full">
      <h1 class="text-2xl font-bold">Template Variables</h1>
      <a @click="setCurrentTemplateVariable({} as TemplateVariable)" class="ml-auto text-blue-500 hover:text-blue-700 cursor-pointer">
        Add new variable</a
      >
    </div>
    <div class="flex flex-1 h-full overflow-y-hidden pt-5">
      <div class="w-[30%] max-w-[450px] min-w-[250px] mr-5 h-full overflow-y-scroll p-5 border">
        <ItemContainer
          v-for="templateVariable in vars"
          :key="templateVariable.id"
          :title="templateVariable.code"
          @click="setCurrentTemplateVariable(templateVariable)"
        >
          <div class="text-sm">{{ templateVariable.label }}</div>
          {{ templateVariable.input_type }}
          <span v-if="templateVariable.input_type === 'singleselect' || templateVariable.input_type === 'multiselect'" class="w-2/5">
            with {{ templateVariable.select_options?.length }} options
          </span>
        </ItemContainer>
      </div>
      <div v-if="currentTemplateVariable" class="grow border p-5 h-full overflow-y-scroll">
        <RemoveTemplateVariable :template-variable="currentTemplateVariable" @click="handleDelete"></RemoveTemplateVariable>
        <TemplateVariableForm :template-variable="currentTemplateVariable" @submit="handleSubmit" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TemplateVariable } from '@/questionnaire/types'
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'
import { useAdminStore } from '../../../admin/adminStore'
import TemplateVariableForm from './TemplateVariableForm.vue'
import RemoveTemplateVariable from './RemoveTemplateVariable.vue'
import type { FormKitNode } from '@formkit/core'
import ItemContainer from './ItemContainer.vue'

const adminStore = useAdminStore()
const { templateVariables } = storeToRefs(adminStore)

const currentTemplateVariable = ref<TemplateVariable | undefined>(undefined)
const setCurrentTemplateVariable = (templateVariable: TemplateVariable) => {
  currentTemplateVariable.value = { ...templateVariable }
}

const vars = computed(() => [...templateVariables.value].sort((a, b) => (a.code > b.code ? 1 : -1)))
setCurrentTemplateVariable(vars.value[0] as TemplateVariable)

const handleSubmit = (data: TemplateVariable, node?: FormKitNode) => {
  return adminStore
    .saveTemplateVariable(data)
    .then(response => {
      setCurrentTemplateVariable(response)
    })
    .catch(err => {
      if (err.response.data?.errors) {
        node?.setErrors(err.response.data.errors)
      }
    })
}

const handleDelete = () => {
  setCurrentTemplateVariable(vars.value[0] as TemplateVariable)
}
</script>
